/* eslint-disable @typescript-eslint/no-misused-promises */

import {
  QueryClient,
  useMutation,
  UseMutationResult,
  useQuery,
  useQueryClient,
  UseQueryResult,
} from "@tanstack/react-query";
import { AxiosPromise } from "axios";
import { axios } from "utils";
import { IEligibilitySurvey } from "Interfaces";
import { queryKeys } from "./";

const GetSurveysInfo = async (): Promise<AxiosPromise<any>> => {
  const url = "/survey/me";
  return await axios({ url, method: "GET" });
};

export const useGetSurveysInfoQuery = (): any => {
  return useQuery([queryKeys.SURVEY_INFO], GetSurveysInfo, {
    enabled: true,
  });
};

/**
 * @description
 * Eligiblity survey apis
 */

const GetEligiblitySurvey = async (): Promise<AxiosPromise<any>> => {
  return await axios({
    url: "/survey/eligibility",
  });
};

export const useGetEligiblitySurveyQuery = (): any => {
  return useQuery([], GetEligiblitySurvey, {
    enabled: true,
  });
};

const SubmitEligiblitySurvey = async (
  body: IEligibilitySurvey
): Promise<AxiosPromise<any>> => {
  return await axios.post("/survey/eligibility", {
    ...body,
  });
};

export const useSubmitEligiblitySurvey = (): UseMutationResult<
  AxiosPromise<any>,
  unknown,
  IEligibilitySurvey,
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation(SubmitEligiblitySurvey, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.GET_USER_PROFILE],
      });
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.SURVEY_INFO],
      });
    },
  });
};

/**
 * @description
 * Personality up 2 survey apis
 */

const GetPeronalitySurvey = async (): Promise<AxiosPromise<any>> => {
  return await axios({
    url: "/survey/personality/response",
    method: "GET",
  });
};

export const useGetPersonalitySurvey = (): UseQueryResult<
  AxiosPromise<any>,
  unknown
> => {
  return useQuery([queryKeys.PERSONALITY_SURVEY], GetPeronalitySurvey, {
    enabled: true,
  });
};

const SubmitPersonalitySurvey = async (
  payload: any
): Promise<AxiosPromise<any>> => {
  return await axios({
    url: "/survey/personality/submit",
    method: "POST",
    data: { ...payload },
  });
};

export const useSubmitPersonalitySuvey = (): UseMutationResult<
  AxiosPromise<any>,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(SubmitPersonalitySurvey, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.GET_USER_PROFILE],
      });
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.SURVEY_INFO],
      });
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.PERSONALITY_SURVEY],
      });
    },
  });
};

/**
 * @description
 * follow up 2 survey apis
 */

const GetFollow1urvey = async (): Promise<AxiosPromise<any>> => {
  return await axios({
    url: "/survey/follow1/response",
    method: "GET",
  });
};

export const useGetFollow1Survey = (): UseQueryResult<
  AxiosPromise<any>,
  unknown
> => {
  return useQuery([], GetFollow1urvey, {
    enabled: true,
  });
};

const SbumitFollow1Survey = async (
  payload: any
): Promise<AxiosPromise<any>> => {
  return await axios({
    url: "/survey/follow1/submit",
    method: "POST",
    data: { ...payload },
  });
};

export const useSubmitFollow1Survey = (): UseMutationResult<
  AxiosPromise<any>,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(SbumitFollow1Survey, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.GET_USER_PROFILE],
      });
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.SURVEY_INFO],
      });
    },
  });
};

/**
 * @description
 * follow up 2 survey apis
 */
const GetFollow2urvey = async (): Promise<AxiosPromise<any>> => {
  return await axios({
    url: "/survey/follow2/response",
    method: "GET",
  });
};

export const useGetFollow2Survey = (): UseQueryResult<
  AxiosPromise<any>,
  unknown
> => {
  return useQuery([], GetFollow2urvey, {
    enabled: true,
  });
};

const SbumitFollow2Survey = async (
  payload: any
): Promise<AxiosPromise<any>> => {
  return await axios({
    url: "/survey/follow2/submit",
    method: "POST",
    data: { ...payload },
  });
};

export const useSubmitFollow2Survey = (): UseMutationResult<
  AxiosPromise<any>,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(SbumitFollow2Survey, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.GET_USER_PROFILE],
      });
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.SURVEY_INFO],
      });
    },
  });
};

/**
 * @description
 * follow up 3 survey apis
 */

const GetFollow3urvey = async (): Promise<AxiosPromise<any>> => {
  return await axios({
    url: "/survey/follow3/response",
    method: "GET",
  });
};

export const useGetFollow3Survey = (): UseQueryResult<
  AxiosPromise<any>,
  unknown
> => {
  return useQuery([], GetFollow3urvey, {
    enabled: true,
  });
};

const SbumitFollow3Survey = async (
  payload: any
): Promise<AxiosPromise<any>> => {
  return await axios({
    url: "/survey/follow3/submit",
    method: "POST",
    data: { ...payload },
  });
};

export const useSubmitFollow3Survey = (): UseMutationResult<
  AxiosPromise<any>,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(SbumitFollow3Survey, {
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.GET_USER_PROFILE],
      });
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.SURVEY_INFO],
      });
    },
  });
};
